module.exports = __webpack_public_path__ + "img/jianceshenqingbiao.778beb9e.jpg";